import { render, staticRenderFns } from "./groups-side-bar-group-view.vue?vue&type=template&id=6f99be9f&scoped=true&"
import script from "./groups-side-bar-group-view.vue?vue&type=script&lang=js&"
export * from "./groups-side-bar-group-view.vue?vue&type=script&lang=js&"
import style0 from "./groups-side-bar-group-view.vue?vue&type=style&index=0&id=6f99be9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99be9f",
  null
  
)

export default component.exports